import { Typography } from "@mui/material"
import PTTranslate from "./PTTranslate"

export const PTTypography = ({
    children,
    ...rest
}) => {
    
    return <Typography {...rest}><PTTranslate tk={children} /></Typography>
}

export default PTTypography